var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgX = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.3,159.8l173.5,229.5h-26.9L154.4,159.8H183.3z M504.3,256c0,137.1-111.2,248.3-248.3,248.3 S7.7,393.1,7.7,256S118.9,7.7,256,7.7S504.3,118.9,504.3,256z M414.2,418.3L289.5,253.5l106-121.1H347l-80,91.4l-69.1-91.4H97.8 l119.6,156.4L104,418.3h48.6l87.5-100l76.5,100H414.2z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgX);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/X.e19648a96afc1bed74b05dcaf9d61159.svg";